import { Component, Vue } from 'vue-property-decorator';
import VueToast from 'vue-toasted';
import Form from '@/components/Form/Form.vue';
import { sendInvoicesRequest, getDraftInvoicesRequest } from '@/utils/api';
import InputField from '@/types/InputField';
import * as constants from './constants';
import { TOAST_OPTIONS } from '@/utils/sharedOptions';
import Invoice from '@/types/Invoice';

Vue.use(VueToast, TOAST_OPTIONS);

@Component({
  components: {
    Form,
  },
})

export default class SendInvoicesForm extends Vue {
  public constants: object = constants;
  public fieldGetDraftInvoicesYear!: number;
  public fieldGetDraftInvoicesMonth!: number;
  public sendInvoicesError: null | string = null;
  public getInvoicesError: null | string = null;
  public getDraftInvoicesFields: InputField[] = [
    {
      placeholder: constants.GET_DRAFT_INVOICES_YEAR_PLACEHOLDER,
      updateInput: this.updateDraftInvoicesYear,
      type: 'number',
      key: constants.GET_DRAFT_INVOICES_YEAR_PLACEHOLDER,
    },
    {
      placeholder: constants.GET_DRAFT_INVOICES_MONTH_PLACEHOLDER,
      updateInput: this.updateDraftInvoicesMonth,
      type: 'number',
      key: constants.GET_DRAFT_INVOICES_MONTH_PLACEHOLDER,
    },
  ];
  public draftInvoicesSelectedToBeSent: Set<string> = new Set<string>();
  public canSendInvoices: boolean = false;
  public draftInvoicesList: InputField[] = [];

  public updateDraftInvoicesYear(input: number): void {
    this.fieldGetDraftInvoicesYear = input;
  }

  public updateDraftInvoicesMonth(input: number): void {
    this.fieldGetDraftInvoicesMonth = input;
  }

  public updateSelectedDraftInvoicesToBeSent(invoiceId: string): void {
    if (this.draftInvoicesSelectedToBeSent.has(invoiceId)) {
      this.draftInvoicesSelectedToBeSent.delete(invoiceId);
    } else {
      this.draftInvoicesSelectedToBeSent.add(invoiceId);
    }
    this.canSendInvoices = this.draftInvoicesSelectedToBeSent.size > 0;
  }

  public async getInvoicesList(): Promise<void> {
    this.getInvoicesError = null;
    try {
      const invoicesList: Invoice[] = await getDraftInvoicesRequest(
        this.fieldGetDraftInvoicesMonth,
        this.fieldGetDraftInvoicesYear,
      );

      this.draftInvoicesList = invoicesList.map((invoice: Invoice): InputField => {
        return {
          type: 'checkbox',
          updateInput: () => this.updateSelectedDraftInvoicesToBeSent(invoice.id),
          key: invoice.invoiceLink,
          name: 'invoices',
          childComponent: this.renderInvoiceOption(
            invoice.invoiceLink,
            invoice.customerName,
          ),
          uniqueId: invoice.id,
        };
      });
    } catch (error) {
      this.getInvoicesError = error.message;
    }
  }

  public renderInvoiceOption(invoiceLink: string, customerName: string): object {
    return {
      template: `
          <a
            style="text-align: left"
            href="${invoiceLink}"
            target="_blank"
          >
            ${customerName}
          </a>
        `,
    };
  }

  public async sendInvoices(): Promise<void> {
    this.sendInvoicesError = null;
    if (!confirm(constants.CONFIRM_SEND(this.fieldGetDraftInvoicesMonth, this.fieldGetDraftInvoicesYear))) {
      return;
    }

    try {
      await sendInvoicesRequest(this.draftInvoicesSelectedToBeSent);
      this.draftInvoicesList = this.draftInvoicesList.filter((input) => {
        return !this.draftInvoicesSelectedToBeSent.has(input.uniqueId!);
      });
      this.canSendInvoices = false;
      this.draftInvoicesSelectedToBeSent.clear();
      this.$toasted.show(constants.SENT_SUCCESSFULLY, TOAST_OPTIONS);
    } catch (error) {
      this.sendInvoicesError = error.message;
    }
  }

}
